// appSlice.ts
import { createSlice } from '@reduxjs/toolkit';
import { AppState } from '../types';

//~ Keep a reference to this slice's name for cleanup in case of persistReducer usage
export const name = 'app';

//~ Initialize your state here
const initialState: AppState = {
    loading: false,
    error: undefined,
};

export const appSlice = createSlice({
    name,
    initialState,
    reducers: {
        //~ Define your synchronous reducers here
        clearApp: () => {
            return initialState;
        },
    },
    extraReducers: () => {
        //~ Add matchers for RTK Query endpoint lifecycles if this slice needs to react
        // builder.addMatcher(endpoints.getApps.matchPending, (state) => {
        //  state.error = undefined;
        //  state.loading = true;
        // }).addMatcher(endpoints.getApps.matchFulfilled, (state, action) => {
        //  state.loading = false;
        //~ Process 'action.payload' here if it affects this slice's *UI* state
        // }).addMatcher(endpoints.getApps.matchRejected, (state, action) => {
        //  state.error = serializeError(action.payload);
        //  state.loading = false;
        // })
        //
        //
    },
    selectors: {
        //~ Define your selectors here
        //select__PROPERTY_NAME_PASCAL__: (sliceState) => sliceState.__PROPERTY_NAME_CAMEL__,

        selectError: (sliceState) => sliceState.error,
        selectLoading: (sliceState) => sliceState.loading,
    },
});

//~ Export defined synchronous reducers here
export const { clearApp } = appSlice.actions;

//~ Export defined selectors here
export const { selectError, selectLoading } = appSlice.selectors;

export const appReducer = appSlice.reducer;
export default appReducer;
